import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_metronic/layout/core';
// import { View } from './components/View';

const EntregasPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Ventas',
      path: '/ventas/entregas',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Mis entregas</PageTitle>
      {/* <View /> */}
    </>
  );
};

export { EntregasPage };
